import { TickerInt } from "interfaces";
import styles from "./NumberTicker.module.scss";

const NumberTicker = ({ id, initial }: TickerInt) => {
  return (
    <div
      id={id}
      className={`${styles["container"]} ${initial.length === 2 && styles.two}`}
    >
      {initial.map((num, index) => (
        <div key={index} className={styles["ticker-container"]}>
          <div className={`${styles["ticker-digits"]} ticker`}>
            <h4
              className={`${styles["ticker-digit"]} bold ticker anim-ticker-digit`}
            >
              {num}
            </h4>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NumberTicker;
